export enum ButtonBuyPlace {
  top = 'top',
  bottom = 'bottom',
}
